import { ReactComponent as ArrowFwdBig } from 'assets/img/arrow-fwd-big.svg';
import premiumFree from 'assets/img/diamond.svg';
import starterFree from 'assets/img/pie-chart.svg';
import { ReactComponent as PremiumIcon } from 'assets/img/premiumSubscr.svg';
import { ReactComponent as StraterIcon } from 'assets/img/proSubscr.svg';
import { ReactComponent as UnlimIcon } from 'assets/img/unlimSubsc.svg';
import cx from 'classnames';
import { Loader } from 'components/loader/loader';
import { SubscriptionListItem } from 'interfaces/state/SubscriptionList';
// eslint-disable-next-line
import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { interval$, isLoading$, is_active_subscription$, product_title$ } from 'selectors/currentSubscription';
import { period$ } from 'selectors/subscriptionList';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import style from './plan.module.scss';
import { message } from 'utils/message';
import { fetchSubscribedPromotion, subscribeToPromotion } from 'creators/promotions';
import { userEmail$ } from 'selectors/auth';
import State from 'interfaces/state/State';

interface IDispatchProps { }
interface IStateProps { }
interface OwnProps {
  plan: SubscriptionListItem;
  handleSelectNewPlan: (id: string, title: string) => void;
  isAnnually: boolean;
}

interface IProps extends IDispatchProps, IStateProps, OwnProps { }

export const Plan = ({ plan, handleSelectNewPlan, isAnnually }: IProps) => {
  const interval = useSelector(interval$);
  const product_title = useSelector(product_title$);
  const is_active_subscription = useSelector(is_active_subscription$);
  const period = useSelector(period$);
  const isLoading = useSelector(isLoading$);
  const dispatch = useDispatch();
  const [email, setEmail] = useState('');
  const userEmail = useSelector(userEmail$);
  const isSubscribed = useSelector((state: State) => state.microPromotion.isSubscribed);

  const renderIcon = () => {
    const icon = {
      starter: <StraterIcon className={style.icon} />,
      premium: <PremiumIcon className={style.icon} />,
      unlimited: <UnlimIcon className={style.icon} />,
      'premium-basic': <PremiumIcon className={style.icon} />,
      'vip / managed': <UnlimIcon className={style.icon} />,
      'starter-free': <img src={starterFree} alt="subscription" className="track-subscription-icon" loading="lazy" />,
      'premium-free': <img src={premiumFree} alt="subscription" className="track-subscription-icon" loading="lazy" />,
    };

    const unnececarySubscriptionTypes = ['free'];

    if (unnececarySubscriptionTypes.includes(plan.title.toLowerCase())) return null;

    return icon[plan.title.toLowerCase()];
  };

  const renderPrice = () => {
    if (plan.title?.toLowerCase() !== 'free') {
      if (isAnnually) {
        return plan.title?.toLowerCase() === 'unlimited' ? Math.round(plan.price_amount * 12) : Math.round((plan.price_amount - plan.price_amount / 10) * 12);
      } else {
        return plan.price_amount;
      }
    } else {
      return false;
    }
  };

  const renderTitle = () => {
    return plan.title?.toLowerCase() === 'free' ? "Trial Account" : plan.title;
  };

  const renderDollar = () => {
    return plan.title?.toLowerCase() !== 'free' ? "$" : "";
  };

  const handleSelectPlan = () => {
    if (plan.title?.toLowerCase() === 'vip / managed') {
      dispatch(subscribeToPromotion(email, 'plan_promotion', message.subscribeToPlanPromotion));
    } else {
      handleSelectNewPlan(plan.product_id, plan.title);
    }
  };

  const isPeriod = period && isAnnually ? 'year' : 'month';
  const isTheSamePeriod = isPeriod === interval;
  const isPlanSelected =
    (plan.title === product_title && is_active_subscription && isTheSamePeriod) ||
    (plan.title === product_title && is_active_subscription);

  const btnCX = cx(style.btn, {
    [style.selected]: isPlanSelected || ((isSubscribed && !isPlanSelected) && ['vip / managed'].includes(plan.title?.toLowerCase())),
  });

  const renderPeriod = useMemo(() => {
    if (plan.title?.toLowerCase() === 'free') {
      return 'Free - 2 weeks trial';
    } else {
      return isAnnually ? 'Annually' : 'Monthly';
    }
  }, [isAnnually]);

  useEffect(() => {
    if (userEmail) setEmail(userEmail!);
  }, [userEmail]);

  useEffect(() => {
    if (userEmail) {
      dispatch(fetchSubscribedPromotion(userEmail, 'plan_promotion'));
    }
  }, [userEmail, dispatch]);

  return (
    <section className={`${style.root} ${isPlanSelected || (isSubscribed && !isPlanSelected) ? '' : style.planShadow}`}>
      <header className={style.header}>
        {renderIcon()}
        <div className={style.topContainer}>
          <h3 className={style.title}>{renderTitle()}</h3>
          <div className={style.priceContainer}>
            <span className={style.dollar}>{renderDollar()}</span>
            <span className={style.price}>{renderPrice()}</span>
            <span className={style.period}>{renderPeriod}</span>
          </div>
        </div>
      </header>
      <div className={style.line}></div>
      <div className={style.options}>
        {plan.feachers?.map((option, index) => {
          const [title, description] = option.split(' - ');
          return (
            <div className={style.optionContainer} key={index}>
              <CheckCircleIcon className={style.checkIcon} />
              <span className={style.option}>
                {title}
                {description && (
                  <>
                    <br />
                    <small>{description}</small>
                  </>
                )}
              </span>
            </div>
          );
        })}
      </div>
      {plan.title?.toLowerCase() !== 'free' && (
        <button
          className={`${btnCX} ${isPlanSelected || (isSubscribed && !isPlanSelected && ['vip / managed'].includes(plan.title?.toLowerCase())) ? '' : style.planBtn}`}
          onClick={handleSelectPlan}
          disabled={isPlanSelected || (isSubscribed && !isPlanSelected)}
        >
          {isSubscribed && !isPlanSelected && ['vip / managed'].includes(plan.title?.toLowerCase()) ? (
            <>Pre Registeration Successful</>
          ) :
            ['vip / managed'].includes(plan.title?.toLowerCase()) && !isLoading ? (
              <>Pre Register</>
            ) : null
          }
          {!['vip / managed'].includes(plan.title?.toLowerCase()) && isPlanSelected && !isLoading && (
            <>Subscribed Plan</>
          )}

          {!['vip / managed'].includes(plan.title?.toLowerCase()) && !isPlanSelected && !isLoading && (
            <>
              Upgrade plan
              <ArrowFwdBig className={`${style.fwdIcon} ${style.arrowIcon}`} />
            </>
          )}

          {isLoading && <Loader />}
        </button>
      )}
    </section>
  );
};
